module.exports = __webpack_public_path__ + "img/exchange-visual.bc72309a.svg";